import { render, staticRenderFns } from "./UserSuggestions.vue?vue&type=template&id=3383fb50&scoped=true"
import script from "./UserSuggestions.vue?vue&type=script&lang=js"
export * from "./UserSuggestions.vue?vue&type=script&lang=js"
import style0 from "./UserSuggestions.vue?vue&type=style&index=0&id=3383fb50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3383fb50",
  null
  
)

export default component.exports